import { createDefaultFetch, IFetchStatus } from 'types/rest/IFetchStatus';
import {
  createDefaultTitleReportData,
  ITitleReportData,
} from '../../../ui-toolkit/orders/interfaces/titleReport/ITitleReport';

export interface ITitleReportState {
  titleReport: ITitleReportData;
  titleReportFetchStatus: IFetchStatus;
  titleReportError: string | null;
  titleReportExist: { [orderId: string]: boolean };
}

export const titleReportInitialState: ITitleReportState = {
  titleReport: createDefaultTitleReportData(),
  titleReportFetchStatus: createDefaultFetch(),
  titleReportError: null,
  titleReportExist: {},
};
